export default __webpack_public_path__ + "static/ico-planeta-d4b1c4a4bfa4ed7a03a4266e98fe36cf.svg";